import { Component, input, OnInit } from '@angular/core';

@Component({
  selector: 'app-open-defects-warning',
  templateUrl: './open-defects-warning.component.html',
  styleUrls: ['./open-defects-warning.component.scss'],
  standalone: false
})
export class OpenDefectsWarningComponent implements OnInit {

  mainClass = input<string>('common-error-panel');
  headerClass = input<string>('primary-color');
  iconSrc = input<string>('assets/icon/warning-outline.svg');
  descClass = input<string>('primary-color');
  titleValue = input<string>('SAFETY_DEFECT_STATUS_DISPLAY');
  titleDesc = input<string>('SAFETY_DEFECT_MESSAGE_DISPLAY');

  constructor() { }

  ngOnInit() { }

}
